import React from 'react'
let PropTypes = React.PropTypes
// COMPONENTES
import { TablaArchivos } from './TablaArchivos.jsx'
// API
import api from '../../apiClient/v1.js'

export class ConsolidadosDisponibles extends React.Component{
    constructor(props){
        super(props)

        this.state = {
            mes: this.props.meses[0]['value'],
            tipo: this.props.tipos[0]['value'],
            archivos: []
        }
        this.buscarArchivos = ()=>{
            let mes = this.state.mes
            let tipo = this.state.tipo
            api.auditorias().getArchivosConsolidados(mes, tipo)
                .then(archivos=>{
                    this.setState({archivos: archivos})
                })
        }
        this.onSelectMesChanged = (evt)=>{
            this.setState({
                mes: evt.target.value
            }, ()=>{
                this.buscarArchivos()
            })
        }
        this.onSelectTipoChanged = (evt)=>{
            this.setState({
                tipo: evt.target.value
            }, ()=>{
                this.buscarArchivos()
            })
        }
    }
    
    componentWillMount(){
        this.buscarArchivos()
    }
    render(){
        return (
            <div className={'container'}>
                <div className={'row'}>
                    <div className={'col-sm-2 form-group '}>
                        <label className="control-label" htmlFor="selectMes">Mes</label>
                        <select className="form-control"  name="selectMes"
                                ref={ref=>this.inputMes=ref}
                                value={this.state.mes}
                                onChange={this.onSelectMesChanged.bind(this)}>
                            >
                            {this.props.meses.map((mes, index)=>{
                                return <option key={index} value={mes['value']}>{`${mes['text']}`}</option>
                            })}
                        </select>
                    </div>
                    <div className={'col-sm-2 form-group '}>
                        <label className="control-label" htmlFor="selectMes">Tipo</label>
                        <select className="form-control"  name="selectTipo"
                                ref={ref=>this.inputTipo=ref}
                                value={this.state.tipo}
                                onChange={this.onSelectTipoChanged.bind(this)}>
                            >
                            {this.props.tipos.map((tipo, index)=>{
                                return <option key={index} value={tipo['value']}>{`${tipo['text']}`}</option>
                            })}
                        </select>
                    </div>
                </div>
                <TablaArchivos
                    archivos={this.state.archivos}
                />
            </div>
        )
    }
}
ConsolidadosDisponibles.propTypes = {
    meses: PropTypes.arrayOf(PropTypes.object),
    tipos: PropTypes.arrayOf(PropTypes.arrayOf)
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/consolidados/ConsolidadosDisponibles.jsx